import { ChartContainer } from '@mui/x-charts/ChartContainer';
import {
  LinePlot,
  MarkPlot,
  lineElementClasses,
  markElementClasses,
} from '@mui/x-charts/LineChart';

function Line({height = 95, color = '#31acee'}) {
  const rand = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;
  const pData = Array.from({ length: 7 }, () => rand(1300, 9999));
  const xLabels = ['Page A','Page B','Page C','Page D','Page E','Page F','Page G'];

  return (
    <ChartContainer
      height={height}
      margin={{ left: 0, right: -10, top: 10, bottom: 0 }}
      series={[{ type: 'line', data: pData }]}
      xAxis={[{ scaleType: 'point', data: xLabels, position: 'none' }]}
      yAxis={[{ position: 'none' }]}
      sx={{
        [`& .${lineElementClasses.root}`]: { stroke: color, strokeWidth: 2 },
        [`& .${markElementClasses.root}`]: { stroke: color, r: 0, fill: '#fff', strokeWidth: 2 },
      }}
      disableAxisListener
    >
      <LinePlot />
      <MarkPlot />
    </ChartContainer>
  );
}

export default Line